const merchantTest = {
    path: 'merchantTest',
    component: resolve => require(['@/pages/admin/merchant/signing/yftWeChat/merchantTest'], resolve),
    meta: {isAccredit: true}
  }
  
  export default merchantTest